<template>
    <vx-modal v-model:visible="visible" padding="standard" size="md" data-test="estimation-modal">
        <template v-slot:header>
            {{ showEstimatedCost ? 'Estimated Cost' : 'Recipient Estimation' }}
        </template>
        <div v-if="showEstimatedCost" class="text-slate-500 text-base flex flex-col gap-4">
            <p>This is only an estimate, as the audience segment can vary in size prior to sending.</p>
            <div>
                <p>Estimated Costs are calculated using:</p>
                <ul class="pl-6 list-disc">
                    <li>Message Type: SMS or MMS</li>
                    <li>Quantity of SMS Segments (message length)</li>
                    <li>Contracted rates (SMS or MMS rate + Carrier Fee)</li>
                    <li>Quantity of contacts within the audience at time of estimation</li>
                </ul>
            </div>
            <p>
                Messages that contain variables can also cause the estimate to diverge from the actual cost at send
                time.
            </p>
        </div>
        <div v-else class="text-slate-500 text-base flex flex-col gap-4">
            <p>
                The total number of recipients is based on several variables that can change all the way up to the time
                a message sends. As a result, we can only provide an exact number once messages go out.
            </p>
            <p>
                However, we do our best to provide an accurate estimation so you have a general idea of how many people
                you'll reach.
            </p>
        </div>
    </vx-modal>

</template>

<script setup lang="ts">
import { VxModal } from '@voxie/frontend-components';
import { useCostVisibility } from '~/composables/useCostVisibility';

const visible = defineModel('visible', { type: Boolean });
const { showEstimatedCost } = useCostVisibility();

</script>
